<template>
  <div class="card card-sidebar-mobile">
    <ul class="nav nav-sidebar" data-nav-type="accordion">
      <template v-for="(items, header) in sortedMenu">
        <li v-if="header" :key="header" class="nav-item-header">
          <div class="text-uppercase font-size-xs line-height-xs">
            {{ header }}
          </div>
          <i :title="header" class="icon-menu font-size-xs"></i>
        </li>
        <template v-for="(item, index) in items">
          <sidebar-menu-item
            v-if="hasPermission(item) || hasRole(item.role)"
            :key="`${header}${index}`"
            :item="item"
            @on:click="$emit('on:click', $event)"
            @toggle-expand="$emit('toggle-expand', $event)"
          />
        </template>

      </template>
    </ul>
  </div>
</template>

<script>
import groupBy from 'lodash-es/groupBy'
import sortBy from 'lodash-es/sortBy'
import SidebarMenuItem from './sidebar-menu-item'
import SidebarPermissionMixin from '../../mixins/SidebarPermissionMixin'

export default {
  name: 'SidebarMenu',
  components: { SidebarMenuItem },
  mixins: [SidebarPermissionMixin],
  props: {
    menu: {
      type: Array,
      default() {
        return []
      },
    },
  },
  computed: {
    sortedMenu() {
      const sorted = sortBy(this.menu, ['order'])
      const grouped = groupBy(sorted, (item) => {
        let header =
          typeof item.header === 'function' ? item.header(this) : item.header
        return header || ''
      })
      return grouped
    },
  },
}
</script>
